<template>
  <div class="container">
    <content-template>
      <template slot="left">線上常識問答比賽</template>
      <template slot="right">
        <li class="media-navbar">
          <a class="is-check">線上常識問答比賽</a>
        </li>
        <li class="media-navbar">
          <router-link to="/name-list">賽事名單公佈</router-link>
        </li>
        <li class="media-navbar media-navbar-none-margin nav-float-left">
          <router-link to="/all-question">過往題目</router-link>
        </li>
      </template>
      <template slot="banner">
        <img src="./banner.jpg" class="top-banner" alt="">
      </template>
      <template slot="content">
        <div class="col-xs-12 col-sm-10 col-sm-offset-1 row">
          <span class="col-xs-4 col-sm-6 news-title none-padding">簡介及比賽 </span>
          <!--<span class="col-xs-8 col-sm-6 ac-time none-padding">報名日期: {{otherDetail.start_time|moment("YYYY年MM月DD日")}}至{{otherDetail.end_time|moment("MM月DD日")}}</span>-->
          <!--<span class="col-xs-8 col-sm-6 ac-time none-padding">報名日期: {{otherDetail.start_time * 1000|datefmt("YYYY年MM月DD日")}}至{{otherDetail.end_time * 1000|datefmt("MM月DD日")}}</span>-->
        </div>
        <div class="col-xs-12 none-padding col-sm-10 col-sm-offset-1" style="margin-top: 30px;" v-html="detail.introduction">

        </div>
        <div class="col-xs-12 start-match">
          <button @click="startMatch">開始比賽</button>
        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      otherDetail: [],
      registerTime: '',
      startTime: '',
      detail: []
    }
  },
  methods: {
    getOther: function () {
      var that = this
      this.$axios.get('/competition/intro')
        .then(function (response) {
          that.detail = response.data.data
          // console.log(that.detail)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 开始比赛
    startMatch: function () {
      this.$router.push('match')
    }
  },
  created () {
    this.getOther()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
  .start-match{
    text-align: center;
    margin-top: 50px;
  }
  .start-match button{
    width:170px;
    height:40px;
    background: #ffffff;
    color: #565656;
    font-size: 18px;
    border-radius:37px;
    border:2px solid rgba(85,113,236,1);
  }
  .row{
    padding: 0px;
    margin-top: 50px;
  }

  @media (max-width: 767px) {
    .row{
      padding-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commonSense/index.vue